import React, { useState, useEffect, useRef, Children } from 'react'
import { Link, useHistory } from "react-router-dom";
import user from '../../assets/img/user.png'
import { AlignJustify, PieChart, Briefcase, Users, Layers, Lock, Bell, Key, HelpCircle, ExternalLink, File, Award, Tag } from 'react-feather';
import { BootstrapTooltip, UserUrl } from '../../Commoncomponet/common';
import { toast } from 'react-toastify'
import $ from 'jquery'
import { getRolesById } from '../../Commoncomponet/Utils';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment'

export function OutsideClick(ref) {
    const [isClicked, setIsClicked] = useState();
    if (window.innerWidth < 1024) {
        if (ref?.current?.classList.item(2) === 'sidebar-show') {
            document.body.classList.add('sidebar-gone')
            document.body.classList.remove('sidebar-show')
        }
    }
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsClicked(true);
            } else {
                setIsClicked(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref]);
    return isClicked;
}


function Header(props) {
    const sidebarColorRef = useRef(null)
    const selectLayoutRef = useRef(null)
    const colorThemeRef = useRef(null)
    const navStickyRef = useRef(null)
    const boxRef = useRef(null);
    const sidebarref = useRef(null);
    const boxOutsideClick = OutsideClick(boxRef);
    const sideOutsideClick = OutsideClick(sidebarref)
    const userInfo = JSON.parse(window.localStorage.getItem('user_info') || '{}')
    const history = useHistory()
    const [permision, setpermision] = useState({})
    const [OpenTab, setOpenTab] = useState('')
    const location = useLocation()

    const COMPANY_LOGO=window.localStorage.getItem('COMPANY_LOGO')
    const COMPANY_FAVICON=	window.localStorage.getItem('COMPANY_FAVICON')
    const COMPANY_NAME=	window.localStorage.getItem('COMPANY_NAME')
    const onHandaleRoles = async () => {
        props?.setIsRouteLoading(true)
        const data = await getRolesById(userInfo?.ROLE)
        if (data.success === true) {
            const obj = data.data.data[0]
            const Roles = { ...obj, ROLES_PERMISSIONS_CATEGORY0: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY0), ROLES_PERMISSIONS_CATEGORY5: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY5), ROLES_PERMISSIONS_CATEGORY2: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY2), ROLES_PERMISSIONS_CATEGORY3: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY3), ROLES_PERMISSIONS_CATEGORY1: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY1), ROLES_PERMISSIONS_CATEGORY4: JSON.parse(obj.ROLES_PERMISSIONS_CATEGORY4), ROLES_OTHER_PERMISSIONS: JSON.parse(obj.ROLES_OTHER_PERMISSIONS) }
            props.setmanuPermission(JSON.parse(obj.ROLES_MENU_PERMISSIONS||'{}'))
            setpermision(Roles)
            props?.setIsRouteLoading(false)
        } else {
            console.log('something want wrong')
            props?.setIsRouteLoading(false)
        }
    }

    const onHandalSwitch = (key) => {
        if(Object.keys(props?.manuPermission||{}).length){
            var obj_flag=false
        const updateData = (items) => items.map(item => {
            if (item.id === key&&item.view==true) {
                obj_flag=true
                return item.view
            }
            if (item.children) {
                return updateData(item.children) 
            }
            return item.view;
        });
            updateData(props.manuPermission)
       return obj_flag
    }
    };
    const [FloatTime,setFloatTime]=useState('')
    function display_ct5() {
        var x = new Date()
        var ampm = x.getHours( ) >= 12 ? ' PM' : ' AM';
        var x1=(x.getDate()<10?('0'+x.getDate()):x.getDate())+"/"+((x.getMonth() + 1)<10?('0'+(x.getMonth() + 1)):(x.getMonth() + 1)) + "/" + x.getFullYear(); 
        x1 = x1 + "  " +  (x.getHours()<10?('0'+x.getHours()):x.getHours())+ ":" +  (x.getMinutes()<10?('0'+x.getMinutes()):x.getMinutes()) + ":" +  (x.getSeconds()<10?('0'+x.getSeconds()):x.getSeconds()) + " " + ampm;
        setFloatTime(x1)
    }

   
         
        var refresh=1000; 
        var mytime=setInterval(()=>display_ct5(),refresh)
    useEffect(() => {
        if(history.location.pathname ==='/gsm_dashboard'){
            sliderbarMini()
        }
        onHandaleRoles()
        document.body.classList.add(
            "light",
            "light-sidebar",
            "theme-white"
        );
        display_ct5()
        let link1 = document.querySelector("link[rel~='icon']");
			let title_el = document.querySelector("title");
        if(COMPANY_FAVICON){
            link1.href =COMPANY_FAVICON
            }else{
                link1.href='data:image/png;base64,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'
            }
            if(COMPANY_NAME){
                title_el.innerHTML =COMPANY_NAME
            }else{
                title_el.innerHTML='GUMSOPS'
            }
    }, []);

    useEffect(() => {
        $("body")
            .off("click")
            .on("click", function (e) {
                if (
                    $(e.target).hasClass("sidebar-show")
                ) {
                    $("body").removeClass("sidebar-show");
                    $("body").addClass("sidebar-gone");
                }
            });
    })

    const [isPTActive, setPTActive] = useState(false)
    const [isMCMctive, setMCMctive] = useState(false)
    const [isPATActive, setPATActive] = useState(false)
    const [isPFTActive, setPFTActive] = useState(false)
    const [isPTTActive, setPTTActive] = useState(false)
    const [isPRTActive, setPRTActive] = useState(false)
    const [isHSTActive, setHSTActive] = useState(false)
    const [isSliderMini, setSliderMini] = useState(false)
    const [isShowSettingPanel, setShowSettingPanel] = useState(false)
    const [isRUActive, setRUActive] = useState(false)
    const [isDeshboard, setDeshboard] = useState(true)
    const [isProfile, setProfile] = useState(false)
    const [isApi, setApi] = useState(false)
    const [isHelp, setHelp] = useState(false)
    const [isTrigger, setTrigger] = useState(false)
    const [isReport, setReport] = useState(false)
    const [isNotify, setNotify] = useState(false)
    const [isIntegrationActive, setIsIntegrationActive] = useState(false)
    // For People Dropdown
    const PToggle = () => {
        if (isPTActive == true) {
            setPFTActive(false)
        }
        if (isPATActive == true) {
            setPATActive(false)
        }
        if (isPTTActive == true) {
            setPTTActive(false)
        }
        setPTActive(!isPTActive)
    }
    // For Attendance people Dropdown
    const PAToggle = () => {
        setPATActive(!isPATActive)
    }
    // For forms people  Dropdown
    const PFToggle = () => {
        setPFTActive(!isPFTActive)
    }
    // For forms people  Dropdown
    const PTToggle = () => {
        setPTTActive(!isPTTActive)
    }
    // For Payroll Dropdown
    const PRToggle = () => {
        setPRTActive(!isPRTActive)
    }
    // For Help/Support Dropdown
    const HSToggle = () => {
        setHSTActive(!isHSTActive)
    }

    const RUToggle = () => {
        setRUActive(!isRUActive)
    }
    // slider is minimize of not
    const sliderMini = (e) => {
        if (document.getElementsByClassName('sidebar-gone').length > 0) {
            document.body.classList.add('sidebar-show')
            document.body.classList.remove('sidebar-gone')

        } else if (window.innerWidth > 1024) {
            document.body.classList.toggle(
                "sidebar-mini"
            );
        }
        else {
            document.body.classList.remove('sidebar-gone')
        }
    }



    $(window).resize(function () {
        // re-render the component
        if (window.innerWidth < 1024) {
            document.body.classList.add('sidebar-gone')
        } else {
            document.body.classList.remove('sidebar-gone')
        }
    })
    useEffect(() => {
        if (window.innerWidth < 1024) {
            document.body.classList.add('sidebar-gone')
        } else {
            document.body.classList.remove('sidebar-gone')
        }
    }, [])

    const sliderbarMini=()=>{
        document.body.classList.add(
            "sidebar-mini"
        );
        setDeshboard(false)
        setPRTActive(false)
        setApi(false)
        setPTActive(false)
        setHSTActive(false)
        setRUActive(false)
        setTrigger(false)
    }

    // slider is minimize of not
    const showSettingPanel = () => {
        setShowSettingPanel(!isShowSettingPanel)
    }

    // select layout either dark(2) or white(1) 
    const selectLayout = (e) => {
        console.log(e.target.value)
        if (e.target.value == "2") {
            document.body.classList.add(
                "dark",
                "dark-sidebar",
                "theme-black"
            );
            document.body.classList.remove(
                "light",
                "light-sidebar",
                "theme-white"
            );
            e.target.checked = true;
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
            // selectLayoutRef.current.innerHTML = '<label className="selectgroup-item"><input type="radio" name="value" className="selectgroup-input-radio select-layout" value="1" ><span className="selectgroup-button">Light</span></label><label className="selectgroup-item"><input type="radio" name="value" className="selectgroup-input-radio select-layout" value="2" checked><span className="selectgroup-button">Dark</span></label>'
        } else {
            document.body.classList.remove(
                "dark",
                "dark-sidebar",
                "theme-black"
            );
            document.body.classList.add(
                "light",
                "light-sidebar",
                "theme-white"
            );
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "black")
            e.target.checked = true;
        }
    }

    const sidebarColor = (e) => {
        if (e.target.value == "2") {
            document.body.classList.add(
                "dark-sidebar"
            );
            document.body.classList.remove(
                "light-sidebar"
            );
            // e.target.checked = true;
            // sidebarColorRef.current.innerHTML = '<label className="selectgroup-item"><input type="radio" name="icon-input" id="sidebar-color" className="selectgroup-input select-sidebar" value="1"><span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip" data-original-title="Light Sidebar"><i className="fas fa-sun"></i></span></label><label className="selectgroup-item"><input type="radio" name="icon-input" id="sidebar-color" className="selectgroup-input select-sidebar" value="2" checked><span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip" data-original-title="Dark Sidebar"><i className="fas fa-moon"></i></span></label>'
        } else {
            document.body.classList.remove(
                "dark-sidebar"
            );
            document.body.classList.add(
                "light-sidebar"
            );
        }
    }

    const colorTheme = (e) => {
        if (e.target.className == "cyan") {
            document.body.classList.add(
                "theme-cyan"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-orange",
                "theme-green",
                "theme-red",
                "theme-white",
                "theme-purple"
            );
            // console.log(colorThemeRef.current.innerHTML)
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" className="active"><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red"><div className="red"></div></li></ul>'
        } else if (e.target.className == "purple") {
            document.body.classList.add(
                "theme-purple"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-orange",
                "theme-green",
                "theme-red",
                "theme-white",
                "theme-cyan"
            );
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple" className="active"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red"><div className="red"></div></li></ul>'
        } else if (e.target.className == "black") {
            document.body.classList.add(
                "theme-black"
            );
            document.body.classList.remove(
                "theme-orange",
                "theme-green",
                "theme-red",
                "theme-white",
                "theme-purple",
                "theme-cyan"
            );
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black" className="active"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red"><div className="red"></div></li></ul>'
        } else if (e.target.className == "orange") {
            document.body.classList.add(
                "theme-orange"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-green",
                "theme-red",
                "theme-white",
                "theme-purple",
                "theme-cyan"
            );
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange" className="active"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red"><div className="red"></div></li></ul>'
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
        } else if (e.target.className == "green") {
            document.body.classList.add(
                "theme-green"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-orange",
                "theme-red",
                "theme-white",
                "theme-purple",
                "theme-cyan"
            );
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green" className="active"><div className="green"className="active" ></div></li><li title="red"><div className="red"></div></li></ul>'
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
        } else if (e.target.className == "red") {
            document.body.classList.add(
                "theme-red"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-orange",
                "theme-green",
                "theme-white",
                "theme-purple",
                "theme-cyan"
            );
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "white")
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" ><div className="white"></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red" className="active"><div className="red"></div></li></ul>'
        } else if (e.target.className == "white") {
            document.body.classList.add(
                "theme-white"
            );
            document.body.classList.remove(
                "theme-black",
                "theme-orange",
                "theme-green",
                "theme-red",
                "theme-purple",
                "theme-cyan"
            );
            var ele = document.getElementById("AlignJustify")
            ele.setAttribute("stroke", "black")
            // colorThemeRef.current.innerHTML = '<ul className="choose-theme list-unstyled mb-0"><li title="white" className="active"><div className="white" ></div></li><li title="cyan" ><div className="cyan"></div></li><li title="black"><div className="black"></div></li><li title="purple"><div className="purple"></div></li><li title="orange"><div className="orange"></div></li><li title="green"><div className="green"></div></li><li title="red"><div className="red"></div></li></ul>'
        }
    }

    const navSticky = () => {
        navStickyRef.current.classList.toggle("sticky")
    }

    const restore = () => {
        document.body.classList.add(
            "light",
            "light-sidebar",
            "theme-white"
        );
        document.body.classList.remove(
            "dark",
            "dark-sidebar",
            "theme-black",
            "theme-cyan",
            "theme-black",
            "theme-orange",
            "theme-green",
            "theme-red",
            "theme-purple"
        )
        var ele = document.getElementById("AlignJustify")
        ele.setAttribute("stroke", "black")
    }

    const onlogout = () => {
        toast.success("Logout Success")
        window.localStorage.setItem('token', '')
        window.localStorage.setItem('user_info', JSON.stringify({}))
        window.localStorage.setItem('login_time', '')
        window.localStorage.setItem('COMPANY_LOGO','')
        window.localStorage.setItem('COMPANY_FAVICON','')
        window.localStorage.setItem('COMPANY_NAME','')
        history.push('/')
    }
    return (
        <>
            <div id="app" className={`light light-sidebar ${sideOutsideClick ? 'sidebar-show' : ''}`} ref={sidebarref}>
                <div className="main-wrapper main-wrapper-1">
                    <div className="navbar-bg"></div>
                    <nav className="navbar navbar-expand-lg  main-navbar sticky" ref={navStickyRef}>
                        <div className="form-inline mr-auto">
                            <ul className="navbar-nav mr-3">
                                <li><a data-toggle="sidebar" className="nav-link nav-link-lg
									collapse-btn" onClick={() => sliderMini()}><AlignJustify id="AlignJustify" color="black" />
                                </a></li>
                            </ul>
                            <form className="form-inline mr-auto">
                                <div className="search-element">
                                    <input className="form-control" type="search" placeholder="Search" aria-label="Search" data-width="200" />
                                    <button className="btn" type="submit">
                                        <i className="fas fa-search"></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                        <ul className="navbar-nav navbar-right">
                            <li className="nav-link nav-link-lg text-dark d-flex tw-flex-col tw-justify-center"><span>{moment(FloatTime,'DD-MM-YYYY hh:mm:ss A').format('DD-MM-YYYY')}</span><span>{moment(FloatTime,'DD-MM-YYYY hh:mm:ss A').format(' hh:mm:ss A')} (GMT {moment(FloatTime,'DD-MM-YYYY hh:mm:ss A').format('Z z')})</span></li>
                            <li><Link to='/tasks' className="nav-link nav-link-lg d-flex tw-flex-col tw-justify-center"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" height="18px" width="18px" class="align-middle"><path d="M388 38h-35V21c0-8-7-16-16-16s-16 8-16 16v17H191V21c0-8-8-16-16-16s-16 8-16 16v17h-35c-31 0-56 25-56 56v357c0 31 25 56 56 56h264c31 0 56-25 56-56V94c0-31-25-56-56-56zm24 413c0 13-11 24-24 24H124c-13 0-24-11-24-24V94c0-13 11-24 24-24h35v17c0 9 7 16 16 16s16-7 16-16V70h130v17c0 9 7 16 16 16s16-7 16-16V70h35c13 0 24 11 24 24v357z"></path><path d="M333 245l-78 77a16 16 0 01-22 0l-43-42c-6-7-6-17 0-23s16-6 23 0l31 31 66-66a16 16 0 0123 23z"></path></svg></Link></li>
                            <li className="dropdown dropdown-list-toggle">

                                <a data-toggle="dropdown" className="nav-link notification-toggle nav-link-lg d-flex tw-flex-col tw-justify-center"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-bell bell"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg></a>
                                <div className="dropdown-menu dropdown-list dropdown-menu-right pullDown">
                                    <div className="dropdown-header">Notifications
                                        <div className="float-right">
                                            <a>Mark All As Read</a>
                                        </div>
                                    </div>
                                    <div className="dropdown-list-content dropdown-list-icons">

                                        <a className="dropdown-item"> <span className="dropdown-item-icon bg-info text-white"> <i className="fas fa-bell"></i></span> <span className="dropdown-item-desc"> <span>No Notification Available</span></span></a>
                                    </div>
                                </div>
                            </li>
                            <li className="dropdown dropdown-list-toggle d-flex">
                            <b class="tw-m-auto tw-text-base tw-text-gray-700"> {userInfo?.FIRST_NAME+' '+userInfo?.LAST_NAME}</b>
                                </li>
                            <li className="dropdown "><a data-toggle="dropdown"
                                className="nav-link dropdown-toggle nav-link-lg nav-link-user d-flex tw-flex-col tw-justify-center"> <img alt="image" src={userInfo?.PROFILE_PHOTO && userInfo?.PROFILE_PHOTO !== '' ? UserUrl + userInfo?.PROFILE_PHOTO : user}
                                    className="user-img-radious-style" /> <span className="d-sm-none d-lg-inline-block"></span></a>
                                <div className="dropdown-menu dropdown-menu-right pullDown">
                                    <Link to="/profiles" className="dropdown-item has-icon"> <i className="far
										fa-user"></i> Profile
                                    </Link>
                                    <BootstrapTooltip title='Tasks' placement='bottom'><> <Link to="/tasks" className="dropdown-item has-icon"><i className="fa fa-tasks"></i> Tasks
                                    </Link></></BootstrapTooltip>
                                    <div className="dropdown-divider"></div>
                                    <a className="dropdown-item has-icon text-danger" onClick={onlogout}> <i className="fas fa-sign-out-alt"></i>
                                        Logout
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </nav>
                    <div className="main-sidebar sidebar-style-2">
                        <aside id="sidebar-wrapper">
                            <div className="sidebar-brand">
                                <Link to=""> <img alt="image" src={COMPANY_LOGO||"data:image/png;base64,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"} className="header-logo" /> <span
                                    className="logo-name"> {COMPANY_NAME||'GUMSOPS'} </span>
                                </Link>
                            </div>
                            <ul className="sidebar-menu">
                                <li className="dropdown">
                                    <a className={isDeshboard ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => (setDeshboard(!isDeshboard))}><PieChart className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} />
                                        <span>Dashboard</span></a>
                                        {onHandalSwitch("MENU1")||userInfo.ROLE === 'ROLE1650614500708'? <ul className={isDeshboard ? "dropdown-menu show" : "dropdown-menu"}>
                                        {onHandalSwitch("MENU1_1")||userInfo.ROLE === 'ROLE1650614500708'?<li className={location?.pathname=='/all-dashboard'?'active':''} ><Link to="" className="nav-link">All</Link></li>:''}
                                        {onHandalSwitch("MENU1_2")||userInfo.ROLE === 'ROLE1650614500708'?<li className={location?.pathname=='/gsm_dashboard'?'active':''}><Link to="/gsm_dashboard" className="nav-link"  onClick={sliderbarMini}>GSM Modem</Link></li>:' '}
                                        {onHandalSwitch("MENU1_3")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/Lora_dashboard'?'active':''}><Link to="/Lora_dashboard" className="nav-link" >Lorawan Modem</Link></li>:''}
                                        {onHandalSwitch("MENU1_4")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/GSM-Smart-Meter-Dashboard'?'active':''}><Link to="/GSM-Smart-Meter-Dashboard" className="nav-link" >GSM Smart Meter</Link></li>:''}
                                        {onHandalSwitch("MENU1_5")||userInfo.ROLE === 'ROLE1650614500708'?<li className={location?.pathname=='/Smart_meter'?'active':''}><Link to="/Smart_meter" className="nav-link" >Lorawan Smart Meter</Link></li>:''}
                                    </ul>:''}
                                </li>
                                {onHandalSwitch("MENU2")||userInfo.ROLE === 'ROLE1650614500708'?<li  className={location?.pathname=='/account'?'active':''}>
                                    <Link to="/account" className={'nav-link'} onClick={() => (setProfile(!isProfile))}><i className='fas fa-globe-americas header-logo' style={{ height: "18px", width: "20px", marginRight: "10px" }} />
                                        <span>Group</span></Link>
                                    {/* <ul className={isProfile ? "dropdown-menu show" : "dropdown-menu"}>
                                        <li><Link to="/account" className="nav-link" >Account</Link></li>
                                    </ul> */}
                                </li>:''}
                                {onHandalSwitch("MENU3")||userInfo.ROLE === 'ROLE1650614500708'? <li className="dropdown" >
                                    <a className={isPRTActive ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => PRToggle()}><i className='fas fa-user-shield fa-lg feather' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span style={{ margineLft: "10px" }}>Consumer</span></a>
                                    <ul className={isPRTActive ? "dropdown-menu show" : "dropdown-menu"}>
                                    {onHandalSwitch("MENU3_1")||userInfo.ROLE === 'ROLE1650614500708'?<li className={location?.pathname=='/All-Consumer-List'?'active':''}><Link to="/All-Consumer-List" className="nav-link" >All Consumer</Link></li>:''}
                                    {onHandalSwitch("MENU3_2")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/All-GSM'?'active':''}><Link to="/All-GSM" className="nav-link" >GSM Modem</Link></li>:''}
                                    {onHandalSwitch("MENU3_3")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/All-Lorawan'?'active':''}><Link to="/All-Lorawan" className="nav-link" >LORAWAN Modem</Link></li>:''}
                                    {onHandalSwitch("MENU3_4")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/All-GSM-Smart-Meter-Consumer'?'active':''}><Link to="/All-GSM-Smart-Meter-Consumer" className="nav-link" >GSM Smart Meter</Link></li>:''}
                                    {onHandalSwitch("MENU3_5")||userInfo.ROLE === 'ROLE1650614500708'?  <li className={location?.pathname=='/Smart_meter'?'active':''}><Link to="/Smart_meter" className="nav-link" >Lorawan Smart Meter</Link></li>:''}
                                    </ul>
                                </li>:''}

                                {userInfo.ROLE === 'ROLE1650614500708' ? <li className={`dropdown ${isPTActive && (isPATActive ? 'active' : '')}`}>
                                    <a className={isPTActive ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => PToggle()}><Lock className='feather' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span style={{ margineLft: "10px" }}>Admin</span></a>
                                    <ul className={isPTActive ? "dropdown-menu show" : "dropdown-menu"}>
                                        <li className={`dropdown ${isPTActive && (isPATActive ? 'active' : '')}`} >
                                            <a className={`menu-toggle nav-link has-dropdown ${isPTActive && (isPATActive ? 'toggled' : '')}`} onClick={() => PAToggle()}>Driver</a>
                                            <ul className={isPTActive ? (isPATActive ? "dropdown-menu show" : "dropdown-menu") : "dropdown-menu"}>
                                                <li className={location?.pathname=='/allmodem'?'active':''}>
                                                    <Link
                                                        to={"/allmodem"}
                                                        className="nav-link"
                                                    >
                                                       GSM Modem
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/'?'active':''}>
                                                    <Link
                                                        to={"/"}
                                                        className="nav-link"
                                                    >
                                                      Lorawan Modem
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/'?'active':''}>
                                                    <Link
                                                        to={"/GSM-Smart-Meter-Driver"}
                                                        className="nav-link"
                                                    >
                                                      GSM Smart Meter
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/'?'active':''}>
                                                    <Link
                                                        to={"/"}
                                                        className="nav-link"
                                                    >
                                                      Lorawan Smart Meter
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/allEVC'?'active':''}>
                                                    <Link
                                                        to={"/allEVC"}
                                                        className="nav-link"
                                                    >
                                                        All EVC
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/MechanicalMeter'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeter"}
                                                        className="nav-link"
                                                    >
                                                        All Mechanical Meter
                                                    </Link>
                                                </li>
                                                {/* <li className={location?.pathname=='/modemtype'?'active':''}>
                                                    <Link
                                                        to={"/modemtype"}
                                                        className="nav-link"
                                                    >
                                                        Modem Type
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/modemmake'?'active':''}>
                                                    <Link
                                                        to={"/modemmake"}
                                                        className="nav-link"
                                                    >
                                                        Modem Make
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/modemmodelnumber'?'active':''}>
                                                    <Link
                                                        to={"/modemmodelnumber"}
                                                        className="nav-link"
                                                    >
                                                        Modem Model Number
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/modemfirmware'?'active':''}>
                                                    <Link
                                                        to={"/modemfirmware"}
                                                        className="nav-link"
                                                    >
                                                        Modem Firmware
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/modemsku'?'active':''}>
                                                    <Link
                                                        to={"/modemsku"}
                                                        className="nav-link"
                                                    >
                                                        Modem SKU
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/modemhardwarev'?'active':''}>
                                                    <Link to={"/modemhardwarev"} className="nav-link">
                                                        Modem Hardware Version
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/server_communication_protocol'?'active':''}>
                                                    <Link to={"/server_communication_protocol"} className="nav-link">
                                                        Server Communication
                                                    </Link>
                                                </li> */}
                                            </ul>
                                        </li>
                                        {/* <li className={`dropdown ${isPTActive && (isPFTActive ? 'active' : '')}`} >
                                            <a className={`menu-toggle nav-link has-dropdown ${isPTActive && (isPFTActive ? 'toggled' : '')}`} onClick={() => PFToggle()}>EVC Driver</a>
                                            <ul className={isPTActive ? (isPFTActive ? "dropdown-menu show" : "dropdown-menu") : "dropdown-menu"}>
                                                <li className={location?.pathname=='/allEVC'?'active':''}>
                                                    <Link
                                                        to={"/allEVC"}
                                                        className="nav-link"
                                                    >
                                                        All EVC
                                                    </Link>
                                                </li>
                                               <li className={location?.pathname=='/EVCmake'?'active':''}>
                                                    <Link
                                                        to={"/EVCmake"}
                                                        className="nav-link"
                                                    >
                                                        EVC Make
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCclass'?'active':''}>
                                                    <Link
                                                        to={"/EVCclass"}
                                                        className="nav-link"
                                                    >
                                                        EVC Class
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCcategory'?'active':''}>
                                                    <Link
                                                        to={"/EVCcategory"}
                                                        className="nav-link"
                                                    >
                                                        EVC Category
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCtype'?'active':''}>
                                                    <Link
                                                        to={"/EVCtype"}
                                                        className="nav-link"
                                                    >
                                                        EVC Type
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCmodelnumber'?'active':''}>
                                                    <Link
                                                        to={"/EVCmodelnumber"}
                                                        className="nav-link"
                                                    >
                                                        EVC Model Number
                                                    </Link>
                                                </li>
                                               
                                                <li className={location?.pathname=='/EVChardwarev'?'active':''}>
                                                    <Link
                                                        to={"/EVChardwarev"}
                                                        className="nav-link"
                                                    >
                                                        EVC Hardware Protocol
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCfirmware'?'active':''}>
                                                    <Link
                                                        to={"/EVCfirmware"}
                                                        className="nav-link"
                                                    >
                                                        EVC Firmware
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/EVCsoftware'?'active':''}>
                                                    <Link
                                                        to={"/EVCsoftware"}
                                                        className="nav-link"
                                                    >
                                                        EVC Software Protocol
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className={`dropdown ${isPTActive && (isMCMctive ? 'active' : '')}`} >
                                            <a className={`menu-toggle nav-link has-dropdown ${isPTActive && (isMCMctive ? 'toggled' : '')}`} onClick={() =>setMCMctive(!isMCMctive)}>Mechanical Meter Driver</a>
                                            <ul className={isPTActive ? (isMCMctive ? "dropdown-menu show" : "dropdown-menu") : "dropdown-menu"}>
                                                <li className={location?.pathname=='/MechanicalMeter'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeter"}
                                                        className="nav-link"
                                                    >
                                                        All Mechanical Meter
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/MechanicalMeterclass'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterclass"}
                                                        className="nav-link"
                                                    >
                                                        Mechanical Meter Class
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/MechanicalMeterType'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterType"}
                                                        className="nav-link"
                                                    >
                                                        Mechanical Meter Type
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/MechanicalMeterBrand'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterBrand"}
                                                        className="nav-link"
                                                    >
                                                        Mechanical Meter Brand
                                                    </Link>
                                                </li>
                                                <li  className={location?.pathname=='/MechanicalMeterManufacturer'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterManufacturer"}
                                                        className="nav-link"
                                                        style={{ lineHeight:'1' }}
                                                    >
                                                        Mechanical Meter Manufacturer
                                                    </Link>
                                                </li>
                                               
                                                <li className={location?.pathname=='/MechanicalMeterModalNo'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterModalNo"}
                                                        className="nav-link"
                                                    >
                                                        Mechanical Meter Model 
                                                    </Link>
                                                </li>
                                                <li className={location?.pathname=='/MechanicalMeterCategory'?'active':''}>
                                                    <Link
                                                        to={"/MechanicalMeterCategory"}
                                                        className="nav-link"
                                                        style={{ lineHeight:'1' }}
                                                    >
                                                        Mechanical Meter Category
                                                    </Link>
                                                </li>
                                                
                                            </ul>
                                        </li> */}
                                        <li className={location?.pathname=='/scripcodeid'?'active':''}><Link className="nav-link" to="/scripcodeid">Script Decode Id</Link></li>
                                        <li className={location?.pathname=='/service_provider'?'active':''}><Link className="nav-link" to="/service_provider">Service Profile</Link></li>
                                        {/* <li className={location?.pathname=='/all-dashboard'?'active':''}><Link className="nav-link" to="/">GSM Signal Strength</Link></li> */}
                                        <li className={location?.pathname=='/create-table'?'active':''}><Link className="nav-link" to="/create-table">Create Table</Link></li>
                                        <li className={location?.pathname=='/scriptlist'?'active':''}><Link className="nav-link" to="/scriptlist">Script List</Link></li>
                                        <li className={location?.pathname=='/admin/dbDetails'?'active':''}><Link className="nav-link" to="/admin/dbDetails">Database Table List</Link></li>
                                        <li className={location?.pathname=='/admin/AttachmentList'?'active':''}><Link className="nav-link" to="/admin/AttachmentList">Consumer Attachment List</Link></li>
                                        <li className={location?.pathname=='/admin/GatewayList'?'active':''}><Link className="nav-link" to="/admin/GatewayList">Gateway List</Link></li>
                                        {/* <li className="dropdown">
                                            <a href="#" className="menu-toggle nav-link has-dropdown" onClick={() => PTToggle()}><span>Time Off</span></a>
                                            <ul className={isPTActive ? (isPTTActive ? "dropdown-menu show" : "dropdown-menu") : "dropdown-menu"}>
                                                <li>
                                                    <Link
                                                        to={"/FormsData/leaveoff"}
                                                        className="nav-link"
                                                    >
                                                        Leaves
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to={"/FormsData/holiday_view"}
                                                        className="nav-link"
                                                    >
                                                        Holidays
                                                    </Link>
                                                </li>
                                            </ul>
                                        </li> */}
                                    </ul>
                                </li> : ''}
                                {onHandalSwitch("MENU11")||userInfo.ROLE === 'ROLE1650614500708'? <li className="dropdown">
                                    <a className={isRUActive ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => RUToggle()}><Users className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Roles & Users*</span></a>
                                    <ul className={isRUActive ? "dropdown-menu show" : "dropdown-menu"}>
                                    {onHandalSwitch("MENU11_2")||userInfo.ROLE === 'ROLE1650614500708'?  <li className={location?.pathname=='/Roles'?'active':''}><Link className="nav-link" to="/Roles">Roles</Link></li>:''}
                                    {onHandalSwitch("MENU11_1")||userInfo.ROLE === 'ROLE1650614500708'?  <li className={location?.pathname=='/user'?'active':''}><Link className="nav-link" to="/user">Users</Link></li>:''}
                                    {onHandalSwitch("MENU11_3")||userInfo.ROLE === 'ROLE1650614500708'?  <li className={location?.pathname=='/UsersGroup'?'active':''}><Link className="nav-link" to="/UsersGroup">Users Group</Link></li>:''}
                                    </ul>
                                </li> : ''}
                                {/* <li className="dropdown">
                                    <a className={isHelp ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => setHelp(!isHelp)}><HelpCircle className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Help/Support</span></a>
                                    <ul className={isHelp ? "dropdown-menu show" : "dropdown-menu"}>
                                        <li className={location?.pathname=='/all-dashboard'?'active':''}><Link className="nav-link" to="/">Bugs And Issues</Link></li>
                                        <li className={location?.pathname=='/all-dashboard'?'active':''}><Link className="nav-link" to="/">Tickets Generation</Link></li>
                                    </ul>
                                </li> */}
                                {onHandalSwitch("MENU4")||userInfo.ROLE === 'ROLE1650614500708'?<li className="dropdown">
                                    <a className={isTrigger ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => setTrigger(!isTrigger)}><i className='fas fa-hand-pointer fa-lg  header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Modem Triggers</span></a>
                                    <ul className={isTrigger ? "dropdown-menu show" : "dropdown-menu"}>
                                    {onHandalSwitch("MENU4_1")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/all-dashboard'?'active':''}><Link className="nav-link" to="/">GSM Modem</Link></li>:''}
                                    {onHandalSwitch("MENU4_2")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/all-dashboard'?'active':''}><Link className="nav-link" to="/">LORAWAN Modem</Link></li>:''}
                                    </ul>
                                </li>:''}
                                {/* <li className="dropdown">
                                    <a className={isReport ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => setReport(!isReport)}><File className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Reports</span></a>
                                    <ul className={isReport ? "dropdown-menu show" : "dropdown-menu"}>

                                        <li><Link className="nav-link" to="/reports">GSM Report</Link></li>
                                        <li><Link className="nav-link" to="/">LORAWAN Report</Link></li>

                                    </ul>
                                </li> */}

{onHandalSwitch("MENU5")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/Notification'?'active':''}>
                                    <Link to='/Notification'><Bell className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Notification Manager</span></Link>
                                </li>:''}
                                {onHandalSwitch("MENU6")||userInfo.ROLE === 'ROLE1650614500708'?<li  className={location?.pathname=='/tags'?'active':''}>
                                    <Link to='/tags' className={'nav-link'}><Tag className='header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span>Tags</span></Link>
                                </li>:''}
                                {/* {userInfo.ROLE === 'ROLE1650614500708'||permision?.ROLES_OTHER_PERMISSIONS?.Tabs?.filter((item) => (item == "API")).length > 0 ? <li className="dropdown">
                                    <a className={isApi ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => setApi(!isApi)}><Key className='feather' style={{ height: "20px", width: "20px", marginRight: "10px" }} /><span style={{ margineLft: "10px" }}>API</span></a>
                                    <ul className={isApi ? "dropdown-menu show" : "dropdown-menu"}>
                                        <li><Link to="/api/api-console" className="nav-link" >Console</Link></li>
                                        <li><Link to="/api/documentationList" className="nav-link" >API Documentation</Link></li>
                                    </ul>
                                </li>:''} */}
                                 {onHandalSwitch("MENU7")||userInfo.ROLE === 'ROLE1650614500708'?<li className="dropdown">
                                    <a className={isIntegrationActive ? "menu-toggle nav-link has-dropdown toggled" : "menu-toggle nav-link has-dropdown"} onClick={() => setIsIntegrationActive(!isIntegrationActive)}><i className='fas fa-cogs fa-lg header-logo' style={{ height: "20px", width: "20px", marginRight: "10px" }}></i><span>Integration</span></a>
                                    <ul className={isIntegrationActive ? "dropdown-menu show" : "dropdown-menu"}>
                                    {onHandalSwitch("MENU7_1")||userInfo.ROLE === 'ROLE1650614500708'?<li className={`dropdown ${isApi && (isApi ? 'active' : '')}`}>
                                            <a className={`menu-toggle nav-link has-dropdown ${isApi && (isApi ? 'toggled' : '')}`} onClick={() => setApi(!isApi)}>API</a>
                                            <ul className={isApi ? (isApi ? "dropdown-menu show" : "dropdown-menu") : "dropdown-menu"}>
                                                {/* <li><Link className="nav-link" to="/">Apis</Link></li> */}
                                                <li className={location?.pathname=='/api/api-console'?'active':''}><Link to="/api/api-console" className="nav-link" >Console</Link></li>
                                                <li className={location?.pathname=='/api/documentationList'?'active':''}><Link to="/api/documentationList" className="nav-link" >API Documentation</Link></li>
                                            </ul>
                                        </li>:''}
                                        {onHandalSwitch("MENU7_2")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/integration'?'active':''}><Link className="nav-link" to="/integration">Plugins</Link></li>:''}

                                    </ul>
                                </li>:''}
                                {onHandalSwitch("MENU8")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/release-notes'?'active':''}>
                                    <Link to='/release-notes' className={'nav-link'}><i className='fas fa-book tw-mr-3'></i><span>Release Notes</span></Link>
                                </li>:''}
                                {onHandalSwitch("MENU9")||userInfo.ROLE === 'ROLE1650614500708'? <li className={location?.pathname=='/Web-Tabs'?'active':''}>
                                    <Link to='/Web-Tabs' className={'nav-link'} onClick={sliderbarMini}><i className='fas fa-globe tw-mr-3'></i><span>Web Tabs</span></Link>
                                </li>:''}
                                {onHandalSwitch("MENU10")||userInfo.ROLE === 'ROLE1650614500708'?<li className="dropdown">
                                    <Link to='/BadDataAnalytics' className={'nav-link'}><i className='fas fa-chart-area tw-mr-3'></i><span> Data Analytics</span></Link>
                                </li>:''}
                            </ul>
                        </aside>
                    </div>
                    {/* Main content */}
                    <div className="main-contents" >
                        <section className="section">
                            {/* {children} */}
                        </section>
                        <div
                            className={boxOutsideClick ? "settingSidebar" : (isShowSettingPanel ? "settingSidebar showSettingPanel" : "settingSidebar")}
                            ref={boxRef}
                        >
                            <a className="settingPanelToggle" onClick={() => showSettingPanel()}> <i className="fa fa-spin fa-cog"></i>
                            </a>
                            <div className="settingSidebar-body ps-container ps-theme-default" style={{ overflow: 'auto' }}>
                                <div className=" fade show active">
                                    <div className="setting-panel-header">Setting Panel
                                    </div>
                                    <div className="p-15 border-bottom">
                                        <h6 className="font-medium m-b-10">Select Layout</h6>
                                        <div className="selectgroup layout-color w-50" onClick={(e) => selectLayout(e)} ref={selectLayoutRef}>
                                            <label className="selectgroup-item">
                                                <input type="radio" name="value" value="1" className="selectgroup-input-radio select-layout" defaultChecked />
                                                <span className="selectgroup-button">Light</span>
                                            </label>
                                            <label className="selectgroup-item">
                                                <input type="radio" name="value" value="2" className="selectgroup-input-radio select-layout" />
                                                <span className="selectgroup-button">Dark</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="p-15 border-bottom">
                                        <h6 className="font-medium m-b-10">Sidebar Color</h6>
                                        <div className="selectgroup selectgroup-pills sidebar-color" onClick={(e) => sidebarColor(e)} ref={sidebarColorRef}>
                                            <BootstrapTooltip title='Light Sidebar' placement="top"><label className="selectgroup-item">
                                                <input type="radio" name="icon-input" value="1" id="sidebar-color" className="selectgroup-input select-sidebar" defaultChecked />
                                                <span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip"
                                                    data-original-title="Light Sidebar"><i className="fas fa-sun"></i></span>
                                            </label></BootstrapTooltip>
                                            <BootstrapTooltip title='Dark Sidebar' placement="top"><label className="selectgroup-item">
                                                <input type="radio" name="icon-input" value="2" id="sidebar-color" className="selectgroup-input select-sidebar" />
                                                <span className="selectgroup-button selectgroup-button-icon" data-toggle="tooltip"
                                                    data-original-title="Dark Sidebar"><i className="fas fa-moon"></i></span>
                                            </label></BootstrapTooltip>
                                        </div>
                                    </div>
                                    <div className="p-15 border-bottom">
                                        <h6 className="font-medium m-b-10">Color Theme</h6>
                                        <div className="theme-setting-options" onClick={(e) => colorTheme(e)} ref={colorThemeRef}>
                                            <ul className="choose-theme list-unstyled mb-0">
                                                <li title="white" className="active">
                                                    <div className="white"></div>
                                                </li>
                                                <li title="cyan">
                                                    <div className="cyan"></div>
                                                </li>
                                                <li title="black">
                                                    <div className="black"></div>
                                                </li>
                                                <li title="purple">
                                                    <div className="purple"></div>
                                                </li>
                                                <li title="orange">
                                                    <div className="orange"></div>
                                                </li>
                                                <li title="green">
                                                    <div className="green"></div>
                                                </li>
                                                <li title="red">
                                                    <div className="red"></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="p-15 border-bottom">
                                        <div className="theme-setting-options" >
                                            <label className="m-b-0" >
                                                <input type="checkbox" name="custom-switch-checkbox" className="custom-switch-input"
                                                    id="mini_sidebar_setting" />
                                                <span className="custom-switch-indicator" onClick={() => sliderMini()}></span>
                                                <span className="control-label p-l-10" onClick={() => sliderMini()}>Mini Sidebar</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="p-15 border-bottom">
                                        <div className="theme-setting-options">
                                            <label className="m-b-0" >
                                                <input type="checkbox" name="custom-switch-checkbox" className="custom-switch-input"
                                                    id="sticky_header_setting" />
                                                <span className="custom-switch-indicator" onClick={() => navSticky()}></span>
                                                <span className="control-label p-l-10" onClick={() => navSticky()}>Sticky Header</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="mt-4 mb-4 p-3 align-center rt-sidebar-last-ele">
                                        <a className="btn btn-icon icon-left btn-primary btn-restore-theme text-white" onClick={() => restore()}>
                                            <i className="fas fa-undo"></i> Restore Default
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default Header